import React from 'react';
import ApprovalsByRole from '../ApprovalsByRole';
import Heading from '@hubins/components/Heading';

const ApprovalsQuantumBackoffice = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>Quantum Backoffice</Heading>
      <ApprovalsByRole role="quantum_backoffice" />
    </>
  );
};

export default ApprovalsQuantumBackoffice;
